// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2nrtQ{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;background:#30a8ff;border-radius:4px 4px 0 0;cursor:default;padding:3px 4px;position:absolute;top:-19px}html[dir=ltr] ._2nrtQ{right:10px;right:1rem}html[dir=rtl] ._2nrtQ{left:10px;left:1rem}._2bR6L{fill:#fff!important;height:12px!important;height:1.2rem!important;margin:0!important;min-height:12px!important;min-height:1.2rem!important;min-width:12px!important;min-width:1.2rem!important;width:12px!important;width:1.2rem!important}.Rik4V{color:#fff;display:inline-block;font-size:12px;font-size:1.2rem;font-weight:400}html[dir=ltr] .Rik4V{margin-left:.6rem}html[dir=rtl] .Rik4V{margin-right:.6rem}", ""]);
// Exports
exports.locals = {
	"activeNotingLabel": "_2nrtQ",
	"activeNotingLabel__icon": "_2bR6L",
	"activeNotingLabel__label": "Rik4V"
};
module.exports = exports;
